import React from 'react';

function WidgetWrapper({ title, onRemove, onExpand, expandState, children }) {
  const getExpandIcon = () => {
    switch (expandState) {
      case 1: // double-wide, next click goes to full
        return '⤢';
      case 2: // full size, next click goes to normal
        return '⤡';
      default: // normal, next click goes to double-wide
        return '↔';
    }
  };

  const getExpandTitle = () => {
    switch (expandState) {
      case 1:
        return 'Expand to full size';
      case 2:
        return 'Return to normal size';
      default:
        return 'Expand to double width';
    }
  };

  return (
    <div className="widget-slot widget-slot-filled">
      <div className="widget-header">
        <span className="widget-title">{title}</span>
        <div className="widget-header-buttons">
          <button
            className="widget-expand"
            onClick={onExpand}
            title={getExpandTitle()}
          >
            {getExpandIcon()}
          </button>
          <button className="widget-remove" onClick={onRemove} title="Remove widget">
            &times;
          </button>
        </div>
      </div>
      <div className="widget-content">
        {children}
      </div>
    </div>
  );
}

export default WidgetWrapper;
